var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolimorphicShapeLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7119_1839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-82.4091 -14.7074C-76.0465 -411.017 79.8373 -195.368 390.332 -204.91C410.481 -173.104 494.552 -113.944 669.651 -131.755C888.524 -154.02 1119.49 -52.8752 1075.58 185.038C1031.68 422.95 922.882 255.012 802.629 616.334C682.376 977.656 761.272 879.692 450.777 1038.09C140.282 1196.48 13.0299 993.559 -110.405 505.647C-233.839 17.7352 -88.7717 381.602 -82.4091 -14.7074Z",
    fill: "#363BC4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7119_1839",
    x: -560,
    y: -655,
    width: 2041,
    height: 2146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_7119_1839"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolimorphicShapeLightBlue);
export default __webpack_public_path__ + "static/media/polimorphic_shape_light_blue.d0ba348bf9ac83e4d93a8a9446a57508.svg";
export { ForwardRef as ReactComponent };